import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logConfigValidation } from './services/configValidator';

// Import i18n configuration (MUST be imported before App)
import './i18n/i18n';

// Valider la configuration au démarrage (seulement en développement)
if (process.env.NODE_ENV === 'development') {
  logConfigValidation(true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
